import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfirmDialogComponent } from './shared/ui/confirm-dialog/confirm-dialog';
import { Toast } from './shared/ui/toast/toast';
@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,ConfirmDialogComponent, Toast
  ],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.css',
})
export class App {
  protected readonly title = signal('POTAMOS');
}
